import React from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { CaseListItem } from 'queries/cases/types';
import ComingSoonTag from 'components/ComingSoonTag/ComingSoonTag';

const Alarm30d: React.FC<{ alarmsInfo?: CaseListItem['alarms_30_days'] }> = ({
  alarmsInfo = { quantity: 0, has_new: false },
}) => {
  const { quantity, has_new } = alarmsInfo ?? { quantity: 0, has_new: false };

  const { t } = useTranslation();
  return (
    <div className="alarms-30d" data-testid="alarms-30d">
      {quantity}
      {has_new && <ComingSoonTag overrideText={t('case:table.new_alarms')} />}
    </div>
  );
};

export default Alarm30d;
